'use client'

import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { FiltersProvider } from '@mercadoni/sinister/dist/cjs/filters/context'
import { useIsMobile } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { Store } from '@mercadoni/sinister/dist/lib/src/entities/store'
import { notFound, useRouter } from 'next/navigation'
import CategoryLayout from './Layout'
import CategoryLogic from './Logic'

const CategoryV3 = ({
  clientModel,
  store,
  categoryReference,
  revalidatePath,
  userAgent,
  googleAnalyticsSessionId,
}: {
  clientModel: ClientModel
  store: Store
  categoryReference: string
  revalidatePath: (url: string) => Promise<void>
  userAgent?: string
  googleAnalyticsSessionId?: string
}) => {
  const { clientId, theme, sortOptions } = clientModel
  const [isMobile] = useIsMobile(userAgent)
  const { filter: copy } = getLocale() || defaultLocale
  const router = useRouter()

  if (!categoryReference) {
    return notFound()
  }

  const handleRouterChange = async (url: string) => {
    await revalidatePath(url)
    await router.push(url)
  }

  return (
    <FiltersProvider
      section="category"
      copy={copy}
      store={store}
      clientId={clientId}
      theme={theme}
      categoryReference={categoryReference}
      sortOptionsConfig={sortOptions}
      googleAnalyticsSessionId={googleAnalyticsSessionId}
    >
      <CategoryLogic
        Wrapper={CategoryLayout}
        clientModel={clientModel}
        onRouterChange={handleRouterChange}
        isMobile={isMobile}
      />
    </FiltersProvider>
  )
}

export default CategoryV3
